// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3UirY","label":"CategoryService_label__7t3GU","location":"CategoryService_location__2_-Dx"};